(function ($) {
  'use strict';
  var App = (function () {
    // Base UI Actions
    function bindUiActions() {
      //Donate button terms
      $('.section.donate .btn--donate').on('click', function (e) {
        if (!$('.section.donate .form-check-input').is(':checked')) {
          e.preventDefault();
        }
      });
    }
    // Other functions like that
    function fooBar() {
      // Do something
    }
    // Modals
    function modals() {
      $('.modal__close, .modal__overlay, .modal-exit').click(function (e) {
        e.preventDefault();
        if ($('.modal:visible .modal__video').length) {
          $('.modal:visible .modal__video iframe').attr('src', $('.modal:visible .modal__video iframe').attr('src').replace('&autoplay=1', ''));
        }
        $(this).closest('.modal').fadeOut();
        $('body').css('overflow', '');
      });
      $(document).keyup(function (e) {
        if (e.keyCode == 27) {
          if ($('.modal:visible .modal__video').length) {
            $('.modal:visible .modal__video iframe').attr('src', $('.modal:visible .modal__video iframe').attr('src').replace('&autoplay=1', ''));
          }
          $('.modal:visible').fadeOut();
          $('body').css('overflow', '');
        }
      });
      $('body').on('click', '[data-openmodal]', function (e) {
        e.preventDefault();
        $('body').css('overflow', 'hidden');
        var modalId = $(this).data('openmodal');
        $('[data-modal="' + modalId + '"]').fadeIn();
        if ($('[data-modal="' + modalId + '"] .modal__video').length) {
          $('[data-modal="' + modalId + '"] .modal__video iframe').attr('src', $('[data-modal="' + modalId + '"] .modal__video iframe').attr('src') + '&autoplay=1');
        }
      });
    }
    return {
      init: function () {
        bindUiActions();
        modals();
      }
    };
  })();
  App.init();
  function moveBG() {
    if ($(window).width() < 560) {
      var bgimg = $('.hero').attr('style');
      $('.main-post').attr('style', bgimg);
      $('.hero').removeAttr('style');
    } else {
      var bgimg = $('.main-post').attr('style');
      $('.hero').attr('style', bgimg);
      $('.main-post').removeAttr('style');
    }
  }
  function scrollToDiv() {
    var div = window.location.hash;
    $('html, body').animate({
      scrollTop: $(div).offset().top - $('.header').outerHeight()
    }, 200);
  }
  function responsive() {
    if (window.matchMedia("(max-width: 767px)").matches) {
      $('.header .btn--donate').appendTo('.menu--main');
    } else {
      $('.menu--main .btn--donate').insertAfter('.header .block-language');
    }
  }
  $(document).ready(function () {
    moveBG();
    responsive();
    $('.accordion--item > a').click(function (e) {
      e.preventDefault();
      $(this).parent().toggleClass('u-open');
    });
    $('.tabs--link').click(function (e) {
      var id = $(this).attr('href');
      if ($(this).is('[href^="#"]')) {
        window.location.hash = id;
        e.preventDefault();
      }
      $('.tabs--link').removeClass('is-active');
      $('.tabs--item').removeClass('u-open');
      $(this).addClass('is-active');
      $(id).addClass('u-open');
    });
    $('.menu--toggle').click(function (e) {
      e.preventDefault();
      $('body').toggleClass('menu-open');
    });
    $('body').on('click', function (e) {
      var menu = $('.menu--main');
      if (!menu.is(e.target) && menu.has(e.target).length === 0 && !$('.menu--toggle').is(e.target)) {
        $('body').removeClass('menu-open');
      }
    });
    $(window).scroll(function (event) {
      if ($(window).scrollTop() > 0) {
        $('body').addClass('header-fixed');
      } else {
        $('body').removeClass('header-fixed');
      }
    });
    if (window.location.hash) {
      scrollToDiv();
    }
    $('.header a[href*="#"]').click(function (event) {
      //if ( location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top - $('.header').outerHeight()
        }, 200, function () {
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) {
            return false;
          } else {
            $target.attr('tabindex', '-1');
            $target.focus();
          };
        });
      }
      //}
    });
    $(window).resize(function (event) {
      moveBG();
      responsive();
    });
    $('.share-btn').click(function (e) {
      $(this).parent().toggleClass('social-share-closed');
    });
    var iframe = document.querySelector('iframe'),
      player;
    if (iframe) {
      player = new Vimeo.Player(iframe);
    }
    $('.paragraph--type--tags').click(function (e) {
      let timestamp = $(this).data('timecode');
      if (timestamp != undefined) {
        e.preventDefault();
      }
      var time_codes_arr = timestamp.split(' - ');
      var time_arr = time_codes_arr[0].split(':');
      if (time_arr.length === 3) {
        var time = (parseInt(time_arr[0]) * 60 * 60) + (parseInt(time_arr[1]) * 60) + parseInt(time_arr[2]);
      } else {
        var time = (parseInt(time_arr[0]) * 60) + parseInt(time_arr[1]);
      }
      player.setCurrentTime(time).then(function (seconds) {
        $('html, body').animate({
          scrollTop: 0
        }, 'fast');
      }).catch(function (error) {
        switch (error.name) {
          case 'RangeError':
            // the time was less than 0 or greater than the video’s duration
            break;
          default:
            // some other error occurred
            break;
        }
      });
    });
    if (window.location.hash) {
      var tabId = window.location.hash;
      $('.tabs--link').removeClass('is-active');
      $('.tabs--item').removeClass('u-open');
      $('.tabs--link[href=\'' + tabId + '\']').addClass('is-active');
      $(tabId).addClass('u-open');
    }
  });
})(jQuery);
